import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import React from 'react';
import { HuchaCardBackground } from './hucha-card-background';

export const HuchaCardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<HuchaCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b960]: 'auto',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'hucha-card-c1', columns: 24 },
						{ name: 'hucha-card-c2', columns: 0 },
						{ name: 'hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b960]: [
						{ name: 'hucha-card-c1', columns: 8 },
						{ name: 'hucha-card-c2', columns: 0 },
						{ name: 'hucha-card-c3', columns: 16 },
					],
					[Breakpoints.b1600]: [
						{ name: 'hucha-card-c1', columns: 5 },
						{ name: 'hucha-card-c2', columns: 6 },
						{ name: 'hucha-card-c3', columns: 13 },
					],
				}}
			>
				{children}
			</Layout>
		</HuchaCardBackground>
	);
};

export const RenovadoresHuchaCardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<HuchaCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b960]: 'auto',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'hucha-card-c1', columns: 24 },
						{ name: 'hucha-card-c2', columns: 24 },
						{ name: 'hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b960]: [
						{ name: 'hucha-card-c1', columns: 12 },
						{ name: 'hucha-card-c2', columns: 12 },
						{ name: 'hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b1280]: [
						{ name: 'hucha-card-c1', columns: 6 },
						{ name: 'hucha-card-c2', columns: 7 },
						{ name: 'hucha-card-c3', columns: 11 },
					],
					[Breakpoints.b1600]: [
						{ name: 'hucha-card-c1', columns: 6 },
						{ name: 'hucha-card-c2', columns: 5 },
						{ name: 'hucha-card-c3', columns: 13 },
					],
				}}
			>
				{children}
			</Layout>
		</HuchaCardBackground>
	);
};
